module.exports = __webpack_public_path__ + "img/box_view.9db7b7f0_2x.0bd2977f.png";